import { baseApi as api } from './api.base.js';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    apiControllerGetBindings: build.query<
      ApiControllerGetBindingsApiResponse,
      ApiControllerGetBindingsApiArg
    >({
      query: () => ({ url: `/loan/map` }),
    }),
    apiControllerMapBind: build.mutation<
      ApiControllerMapBindApiResponse,
      ApiControllerMapBindApiArg
    >({
      query: (queryArg) => ({
        url: `/loan/map/bind`,
        method: 'POST',
        body: queryArg.bindDto,
      }),
    }),
    apiControllerMapUnbind: build.mutation<
      ApiControllerMapUnbindApiResponse,
      ApiControllerMapUnbindApiArg
    >({
      query: (queryArg) => ({
        url: `/loan/map/unbind`,
        method: 'POST',
        body: queryArg.unbindDto,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as generatedApi };
export type ApiControllerGetBindingsApiResponse =
  /** status 200 Returns mapping between wallets and projects */ LoanBindingsResponse;
export type ApiControllerGetBindingsApiArg = void;
export type ApiControllerMapBindApiResponse =
  /** status 201 Returns binding result */ LoanStatusResponse;
export type ApiControllerMapBindApiArg = {
  /** Symbol and label binding data */
  bindDto: BindDto;
};
export type ApiControllerMapUnbindApiResponse =
  /** status 200 Returns unbinding result */ LoanStatusResponse;
export type ApiControllerMapUnbindApiArg = {
  /** Symbol to unbind */
  unbindDto: UnbindDto;
};
export type LoanBindingItem = {
  /** Mapping ID */
  id: number;
  /** Token symbol */
  symbol: string;
  /** Human-readable label */
  label: string;
  /** Created date */
  date: string;
};
export type LoanBindingsResponse = {
  /** Operation status */
  status: boolean;
  data: LoanBindingItem[];
};
export type LoanStatusResponse = {
  /** Operation status */
  status: boolean;
  /** Optional info/error message */
  message?: string;
};
export type BindDto = {};
export type UnbindDto = {};
